module.exports = __webpack_public_path__ + "static/img/logo-banner.3bd75b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/logo-banner.png
// module id = WhrD
// module chunks = 9